module.exports = __webpack_public_path__ + "static/media/MuseoSansRegular.f30df4fe.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansRegular/MuseoSansRegular.eot
// module id = 244
// module chunks = 0